import Chart from 'react-apexcharts';
import userAndOrganizationActivityAnalyticService from '../../../services/user-and-organization-activity-analytics.service';
import { Card } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

const UserRoleDistribution = () => {
  const [userRoleDistribution, setUserRoleDistribution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserRoleDistribution = async () => {
      setError(false);
      setLoading(true);
      try {
        const userRoleDistribution =
          await userAndOrganizationActivityAnalyticService.getUserRoleBreakdown();
        setUserRoleDistribution({
          Providers: userRoleDistribution?.provider_staff_count,
          'Support Staff': userRoleDistribution?.support_staff_count,
        });
      } catch (err) {
        console.error('Error fetching role distribution:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRoleDistribution();
  }, []);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load user role distribution.
      </div>
    );
  }

  const chartOptions = {
    labels: Object.keys(userRoleDistribution),
    colors: ['#4F46E5', '#16A34A', '#F59E0B'],
    legend: {
      position: 'bottom',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
              formatter: (val) => val,
            },
            total: {
              show: true,
              formatter: function (w) {
                const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                return total.toString();
              },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  const series = Object.values(userRoleDistribution);

  return (
    <div className="mt-3">
      <Chart options={chartOptions} series={series} type="donut" height={300} />
    </div>
  );
};

export default UserRoleDistribution;
